import { __decorate, __metadata } from "tslib";
import { Component, Model, Prop, Watch } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
import { DateTime, Info } from "luxon";
function isRange(selected) {
    return selected instanceof Array && selected.length == 2;
}
function dayEquality(left, right) {
    return left.toFormat("yyyy-MM-dd") == right.toFormat("yyyy-MM-dd");
}
export const COMPONENT_NAME = "LvCalendarMonth";
/**
 * Display an interactive calendar month
 */
let LvCalendarMonth = class LvCalendarMonth extends UIComponent {
    constructor() {
        super(...arguments);
        this.weekDays = [];
        this.weeks = [];
        this.nextCandidateForSelection = null;
    }
    mounted() {
        this.computeWeeks();
    }
    get classList() {
        return [
            this.selectable ? "selectable" : null,
            this.selectable,
        ].filter(x => x != null);
    }
    computeWeeks() {
        const monthDate = DateTime.fromISO(this.monthDate);
        const weeks = [];
        const firstDay = monthDate.startOf("month");
        const firstWeek = firstDay.startOf("week");
        const lastDay = monthDate.endOf("month");
        const lastWeek = lastDay.endOf("week");
        let currentDay = firstWeek;
        let currentWeek = [currentDay];
        while (currentDay <= lastWeek) {
            const day = currentDay.plus({ day: 1 });
            if (day.weekNumber == currentDay.weekNumber) {
                currentWeek.push(day);
            }
            else {
                weeks.push(currentWeek);
                currentWeek = [day];
            }
            currentDay = day;
        }
        this.weeks = weeks;
        this.weekDays = Info.weekdays("short");
    }
    isDaySelected(day) {
        if (!this.selected)
            return false;
        if (isRange(this.selected)) {
            return this.selected.some(x => x !== null && dayEquality(day, DateTime.fromISO(x)));
        }
        else {
            return dayEquality(day, DateTime.fromISO(this.selected));
        }
    }
    isDayDisabled(day) {
        if (this.disabledDays) {
            return this.disabledDays(day.toISO());
        }
        return false;
    }
    isDayHidden(day) {
        return day.month != DateTime.fromISO(this.monthDate).month;
    }
    isDayInRange(day) {
        if (!this.selected) {
            return false;
        }
        else if (isRange(this.selected)) {
            const [nativeFrom, nativeTo] = this.selected;
            if (nativeTo == null && this.nextCandidateForSelection == null)
                return false;
            const from = DateTime.fromISO(nativeFrom);
            const to = nativeTo ? DateTime.fromISO(nativeTo) : this.nextCandidateForSelection;
            return (from.startOf("day") <= day.startOf("day") &&
                to.startOf("day") >= day.startOf("day"));
        }
        else {
            return false;
        }
    }
    isRangeStart(day) {
        if (!this.selected || !isRange(this.selected))
            return;
        const [nativeFrom] = this.selected;
        const from = DateTime.fromISO(nativeFrom);
        return dayEquality(from, day);
    }
    isRangeEnd(day) {
        if (!this.selected || !isRange(this.selected))
            return;
        const [, nativeTo] = this.selected;
        if (!nativeTo)
            return false;
        const to = DateTime.fromISO(nativeTo);
        return dayEquality(to, day);
    }
    onDayClick(day) {
        if (!this.selectable)
            return;
        if (this.isDayDisabled(day))
            return;
        if (this.selectable == "range") {
            this.selectDayForRange(day);
        }
        else {
            this.selectSingleDay(day);
        }
        this.$nextTick(() => this.$emit('selected', day));
    }
    onDayMouseEnter(day) {
        this.nextCandidateForSelection = day;
    }
    onDayMouseLeave(day) {
        this.nextCandidateForSelection = null;
    }
    selectDayForRange(day) {
        if (!this.selected) {
            this.$emit("change", [day.toISO(), null]);
        }
        else if (isRange(this.selected)) {
            const [nativeFrom, nativeTo] = this.selected;
            const from = DateTime.fromISO(nativeFrom);
            const to = nativeTo ? DateTime.fromISO(nativeTo) : null;
            if (to == null) {
                if (day.startOf("day") < from.startOf("day")) {
                    this.$emit("change", [day.toISO(), nativeFrom]);
                }
                else {
                    this.$emit("change", [nativeFrom, day.toISO()]);
                }
            }
            else {
                this.$emit("change", [day.toISO(), null]);
            }
        }
    }
    selectSingleDay(day) {
        this.$emit("change", day.toISO());
    }
};
__decorate([
    Prop({ type: String, required: false, default: () => DateTime.now().toISO() }),
    __metadata("design:type", String)
], LvCalendarMonth.prototype, "monthDate", void 0);
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", String)
], LvCalendarMonth.prototype, "selectable", void 0);
__decorate([
    Prop({ type: Function, required: false, default: null }),
    __metadata("design:type", Function)
], LvCalendarMonth.prototype, "disabledDays", void 0);
__decorate([
    Model("change", { required: false, default: null }),
    __metadata("design:type", Object)
], LvCalendarMonth.prototype, "selected", void 0);
__decorate([
    Watch("monthDate"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LvCalendarMonth.prototype, "computeWeeks", null);
LvCalendarMonth = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvCalendarMonth);
export default LvCalendarMonth;
//# sourceMappingURL=script.js.map